import { tools } from '@worktango/ai-assistant/react';
import yaml from 'yaml';

import { fetchCurrentAccountQuery } from '~/behaviors/react-query/account';

export const getCurrentUserTool = tools.createTool({
  name: 'get_current_user',
  description: 'Get basic information about the current user',
  displayName: 'Getting user info',
  pastTenseDisplayName: 'Got your user information',
  fulfill: async () => {
    const user = await fetchCurrentAccountQuery();
    return yaml.stringify(user);
  },
});
